



































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { OperatingStatus, OperatingStatusText } from '@/enum';
import { FormModel } from 'ant-design-vue';
import { validateRuleData } from '@/decorators';
import util from '@/utils/util';

@Component
export default class AddEditSkuMapping extends Vue {
  protected static initFormData(): TypeProductOriginalLabel.MappingFormData {
    return {
      product_sku: '',
      mapping_list: [
        util.createTableRowKey({
          relation_barcode: '',
          third_part_platform: '',
        }),
      ],
    };
  }
  public visible: boolean = false;
  protected tableRow: number = 0;
  protected labelCol: TypeBase.Col = { span: 4 };
  protected wrapperCol: TypeBase.Col = { span: 20 };
  protected operatingStatusText: TypeEnum.OperatingStatusText = OperatingStatusText;
  @Prop({ type: String, default: OperatingStatus.view })
  protected mode!: TypeBase.OperatingStatus;
  @Prop({ type: Object, default: () => {} })
  protected data!: TypeProductOriginalLabel.DataItem;
  protected platformList: TypeCommon.PlatformList = [];
  protected platformAccountList: TypeCommon.PlatformAccountList = [];
  protected formData: TypeProductOriginalLabel.MappingFormData = AddEditSkuMapping.initFormData();
  protected formDataRule: any = {};
  protected columns: TypeBase.TableColumn[] = [];
  protected timer: NodeJS.Timeout | null = null;
  @validateRuleData('/api/v1/product_original_label/add')
  protected validateRuleChange(data: any): void {
    this.formDataRule = this.$util.mergeValidate(data, {});
  }
  protected get isEdit(): boolean {
    const h = this.$createElement;
    const isEdit = this.mode === OperatingStatus.edit;
    // 表格列数据
    this.columns = [
      {
        title: (
          <div>
            <span class='required-tag'>{this.t('原标商品编码')}</span>
            <a-tooltip overlayClassName='expandTooltip'>
              <div slot='title'>{this.t('例如  A123-ABC 不允许，AA123-ABC 允许；123-456 不允许，AB123-456 允许，A123+456 允许。')}</div>
              <a-icon class='ml-5 note-tip' type='question-circle'></a-icon>
            </a-tooltip>
          </div>
        ),
        width: 300,
        scopedSlots: { customRender: 'product_sku' },
      },
      {
        title: this.t('来源仓库'),
        scopedSlots: { customRender: 'third_part_platform' },
      },
    ];
    if (!isEdit) {
      this.columns.push({
        title: this.t('操作'),
        key: 'tags2',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
      });
    }
    return isEdit;
  }
  @Watch('data')
  protected onDataChange(data: TypeProductOriginalLabel.DataItem): void {
    this.formData = {
      product_sku: data.product_sku,
      mapping_list: [
        this.$util.createTableRowKey({
          relation_barcode: data.relation_barcode,
          third_part_platform: data.third_part_platform,
          index: this.tableRow,
        }),
      ],
    };
  }
  @Watch('visible')
  protected onVisibleChange(): void {
    if (!this.visible) {
      const formDataRef = this.$refs.formDataRef as FormModel;
      this.formData = AddEditSkuMapping.initFormData();
      formDataRef.resetFields();
    }
  }
  protected async addOriginalLabel(params: TypeProductOriginalLabel.MappingFormData): Promise<void> {
    const res = await this.$api.product.addOriginalLabel(params);
    if (res.code === 0) {
      this.visible = false;
      this.$message.success(this.t('添加成功'));
      this.$emit('success');
    }
  }
  protected async searchSkuList(params: TypeProductCommon.SearchSkuListParam): Promise<TypeProductCommon.SearchSkuListResult> {
    const res = await this.$api.product.searchSkuList<TypeProductCommon.SearchSkuListResult>(params, {
      loading: false,
    });
    return res.data || [];
  }
  protected async updateOriginalLabel(params: TypeProductOriginalLabel.EditMappingFormData): Promise<void> {
    const res = await this.$api.product.updateOriginalLabel(params);
    if (res.code === 0) {
      this.visible = false;
      this.$message.success(this.t('保存成功'));
      this.$emit('success');
    }
  }
  protected async handleSearchSkuList(value: string): Promise<TypeProductCommon.SearchSkuListResult> {
    return await this.searchSkuList({
        keyword: value,
        is_select_flag: true,
      });
  }
  protected handleAdd(): void {
    this.formData.mapping_list.push(
      this.$util.createTableRowKey({
        relation_barcode: '',
        third_part_platform: '',
      })
    );
  }
  protected handleRemove(index: number): void {
    this.formData.mapping_list.splice(index, 1);
  }
  protected handleSubmit(): void {
    const formDataRef = this.$refs.formDataRef as FormModel;
    formDataRef.validate((valid: boolean) => {
      if (valid) {
        if (this.isEdit) {
          this.updateOriginalLabel({
            product_id: this.data.product_id,
            relation_barcode: this.formData.mapping_list[0].relation_barcode,
            third_part_platform: this.formData.mapping_list[0].third_part_platform,
            product_status: this.data.product_status,
          });
        } else {
          this.addOriginalLabel(this.formData);
        }
      }
    });
  }
}
